import { defineComponent, onMounted, onUnmounted, computed } from 'vue'
import ApiDocsMenuComponent from '@/modules/api/components/ApiDocsMenuComponent/ApiDocsMenuComponent.vue'
import CallWidget from '@/features/CallWidget/CallWidget.vue'
import ApiDocsHeader from '@/modules/api/components/ApiDocsHeader/ApiDocsHeader.vue'
import ApiDocsMain from '@/modules/api/components/ApiDocsMain/ApiDocsMain.vue'
import { useUIStore } from '@/store/ui/ui'
import { useMainStore } from '@/store/main/main'
import { Breakpoints } from '@/enum/Breakpoints'

export default defineComponent({
  name: 'ApiDocsLayout',
  components: {
    ApiDocsMenuComponent,
    CallWidget,
    ApiDocsHeader,
    ApiDocsMain,
  },
  setup() {
    const notebookBreakpoint = Breakpoints.NOTEBOOK

    const uiStore = useUIStore()
    const mainStore = useMainStore()

    const isMobile = computed(() => mainStore.isMobile)

    const checkMenuVisibility = () => {
      if (window.innerWidth < notebookBreakpoint && uiStore.getIsApiDocsMenuOpen) {
        toggleMenu()
      }
    }

    const toggleMenu = () => {
      uiStore.toggleApiDocsMenu()
      localStorage.setItem('isApiDocsMenuOpen', uiStore.getIsApiDocsMenuOpen.toString())
    }

    onMounted(() => {
      window.addEventListener('resize', checkMenuVisibility)
    })

    onUnmounted(() => {
      window.removeEventListener('resize', checkMenuVisibility)
    })

    return { uiStore, isMobile, toggleMenu }
  },
})
